import { Box } from '@mui/material'
import { t } from 'i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
// import SaveAsDraft from 'src/components/views/EscritosLexnet/components/shared/components/Submit/SaveAsDraft/SaveAsDraft'
import useSubmitFormActions from 'src/components/views/EscritosLexnet/components/shared/hooks/useSubmitFormActions'
import { useAlertContext } from 'src/contexts/AlertContext'

const styles = {
  buttonsContainer: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'flex-end'
  }
}

type SubmitButtonsPropsType = {
  disabled?: boolean
  onCleanForm?: () => void
}

function SubmitButtons({
  disabled = false,
  onCleanForm = () => {}
}: SubmitButtonsPropsType): JSX.Element {
  const { clearForm, submit } = useSubmitFormActions()
  const { addAlert } = useAlertContext()

  return (
    <Box sx={styles.buttonsContainer}>
      <ButtonPrimaryOutlined
        variant="text"
        disabled={disabled}
        onClick={() => {
          addAlert({
            message: t('dialog.message.remove_all_fields'),
            type: AlertType.INFO,
            action: async () => {
              onCleanForm()
              await clearForm()

              addAlert({
                message: t('dialog.message.removed_info_success'),
                type: AlertType.SUCCESS
              })
            }
          })
        }}
      >
        {t('views.escritos_lexnet.clean')}
      </ButtonPrimaryOutlined>
      {/* <SaveAsDraft /> */}
      <ButtonPrimaryOutlined type="submit" disabled={disabled} onClick={submit}>
        {t('views.escritos_lexnet.sign_and_send')}
      </ButtonPrimaryOutlined>
    </Box>
  )
}

export default SubmitButtons
